import React, { useEffect, useState } from 'react';
import { getAllNfts } from 'APIs/HotAuctionApi';
import NftData from 'interfaces/NftData.interface';
import NftCard from 'components/molecules/Card/NftCard';
import { Box } from '@mui/material';

const CollectedBody = () => {
  const [nfts, setNfts] = useState<NftData[]>([]);
  useEffect(() => {
    const getNfts = async () => {
      const res = await getAllNfts();
      if (res.data) {
        setNfts([...res.data]);
      }
    };
    getNfts();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          margin: '40px 0px',
          gap: '40px',
          maxWidth: '1300px',
          justifyContent: 'start',
        }}
      >
        {nfts.map((item, index) => {
          return (
            <NftCard
              key={item.id}
              ownerName={item.user.name}
              splitWith=""
              name={item.user.name}
              price={item.reservedBid.toString()}
              currency={'ETH'}
              views={item.views}
              image={item.image}
              id={item.id}
              userAvatar={item.user.avatar}
              poster={item.poster}
            />
          );
        })}
      </Box>
    </>
  );
};

export default CollectedBody;
